import { useQuery, UseQueryExecute } from "urql";
import { SongFieldsFragmentDoc, SongUb } from "../gql/graphql";
import { useFragment } from "../gql";
import { songsFullQuery } from "./songQueries";

export function useSongsQuery(): {
  songs: readonly SongUb[];
  fetching: boolean;
  reexecuteQuery: UseQueryExecute;
} {
  const [result, reexecuteQuery] = useQuery({
    query: songsFullQuery,
  });
  const { data, fetching } = result;
  // Unmask fragment data using useFragment (supports arrays directly)
  const songs = useFragment(SongFieldsFragmentDoc, data?.songs);
  return {
    songs: songs ?? [],
    fetching,
    reexecuteQuery,
  };
}
